import {MxGridCustomizerEvent} from '../../mx-grid/services/mx-grid-customizer-event';
import {AssignmentConfig} from './mx-assignment-grid';

export class MxAssignmentGridCustomizerEvent {
    private _assignmentConfig: AssignmentConfig = {};
    gridCustomizerEvent: MxGridCustomizerEvent;

    get assignmentConfig(): AssignmentConfig {
        return this._assignmentConfig;
    }

    /**
     * Customize assignment dialog configuration: specify assignment dialog title,
     * keyField (Defines the key field in the data, used to uniquely identify items),
     * displayField (Specifies the field in the data to be displayed as the item's label)
     * extractor (A function to extract the unique identifier from an item)
     * fieldConverter (A function to map the fields of the assessment grid to the report template) */
    customizeAssignmentDialog(assignmentConfig: AssignmentConfig): MxAssignmentGridCustomizerEvent {
        Object.assign(this._assignmentConfig, assignmentConfig);
        return this;
    }

    extractId?(value: any): number | string;
}
